import { useMutation } from '@tanstack/react-query'
import { syncMeetingItems } from '../api/meetingApi'
import type { MinuteItemInput, MinuteItemKind } from '../../minuteItems/types'

/**
 * Basit içerik (Gündem/Prensip/Karar) senkron mutasyonu (044) — detay ekranında hep düzenlenebilir; her
 * ekle/düzenle/sil anında bu uçla kaydedilir (Temel Bilgiler'den bağımsız). Başarıda güncel liste döner;
 * çağıran satırları tazeler. Aksiyon senkronuyla ({@code useSyncMeetingActions}) aynı desen.
 */
export function useSyncMeetingItems(meetingId: number, kind: MinuteItemKind) {
  return useMutation({
    mutationFn: (items: MinuteItemInput[]) => syncMeetingItems(meetingId, kind, items),
  })
}
